export const DIALOGS = {
  // —— 梦境教学：追寻一段未完成的留言 ——
  onboarding_dream: [
    { s: '系统', t: '一座没有出口的旧站台。广告屏还亮着，却只会重复几个失去来历的热词。' },
    { s: '陌生女声', t: '顾言。如果你还记得自己的名字，就向前走。' },
    { s: '顾言', t: '这里不是冷冻中心……你是谁？' },
    {
      s: '系统',
      t: '破损的广播反复播放同一句话：「如果你还能听见，请替我把……」',
      choice: [
        { label: '寻找声音的来源', goto: 'dream_go' },
        {
          label: '从梦中醒来（跳过教学）',
          effect: { flags: { onboarding_skip_choice: true } },
          goto: 'dream_skip',
        },
      ],
    },
    { label: 'dream_go' },
    {
      s: '系统',
      t: '（WASD 移动。靠近发光的旧广播，按 E 调查。）',
    },
    { label: 'dream_skip' },
    { s: '顾言', t: '……先醒过来。活下来，再找这道声音。' },
  ],
  onboarding_wake: [
    { s: '冷冻系统', t: '冷冻程序终止。苏醒程序启动。' },
    { s: '顾言', t: '……铁锈。霉味。刚才是谁在说话？' },
    {
      s: '系统',
      t: '（先换上衣服，再离开冷冻中心。梦里的刻痕不会保留，但你的选择会被世界记住。）',
    },
  ],
  onboarding_wall_1: [
    { s: '旧广播', t: '「如果你还能听见，请替我把……把……」' },
    { s: '顾言', t: '后半句被删掉了。这里的人仍能发声，却没有一句话属于自己。' },
    { s: '陌生女声', t: '先把散落的字捡回来。门只认得完整的语言。' },
  ],
  onboarding_wall_2: [
    { s: '残句', t: '「人仍能发声，却失去了＿＿。」' },
    { s: '顾言', t: '地上那些光点……是汉字？' },
    {
      s: '系统',
      t: '（靠近发光的「言」「语」，按 E 拾取。收集到的字不会在言锋战中被消耗。）',
    },
  ],
  onboarding_wall_3: [
    { s: '完整留言', t: '「人仍能发声，却失去了语言。完整的话，能够让记忆留下。」' },
    { s: '顾言', t: '语言不是弹药。它是一个人证明自己来过的痕迹。' },
    { s: '陌生女声', t: '小心。回声不愿让任何一句话完整。它会用三种形状拦住你。' },
    { s: '系统', t: '（依次穿过弹幕、言锋、骇入三个短战场。正式旅途中，战场形态会随机出现。）' },
  ],
  onboarding_wall_4: [
    { s: '要石', t: '「把不愿失去的字留在这里。」' },
    { s: '顾言', t: '它不是墓碑。它在替那些说不完话的人记住。' },
    { s: '系统', t: '（靠近要石按 E：激活复活点并刻字。正式旅途中，要石也会保存进度。）' },
  ],
  onboarding_wall_5: [
    { s: '旧广播', t: '「如果你还能听见，请替我把……」' },
    { s: '顾言', t: '把什么带到未来？' },
    { s: '陌生女声', t: '请替我把话说完。也替那些再也说不完的人，把名字留下。' },
    { s: '系统', t: '（前方金色裂隙通往现实。慈悲与残忍会继续影响人物态度、AI 剧情与最终选择。）' },
  ],
  onboarding_battle_intro: [
    { s: '顾言', t: '那个人一直在说“没事、都行、哈哈”……可他明明在求救。' },
    { s: '回声', t: '认真就输了……别说了……别说了……' },
    {
      s: '系统',
      t: '（第一形态：弹幕菜单战。选择行动并移动红心躲避；调查能看见敌人未说出口的部分。）',
    },
  ],
  onboarding_after_menu: [
    { s: '回声', t: '我那天其实想告诉她……可是大家都说，认真就输了。' },
    { s: '系统', t: '回声已经失去反抗能力。顾言可以补全它的话，也可以让它永远消失。' },
    {
      s: '顾言',
      t: '最后一句，由我来决定。',
      choice: [
        {
          label: '补全他的话',
          effect: { mercy: 1, flags: { onboarding_chose_mercy: true } },
        },
        {
          label: '让回声彻底消失',
          effect: { violence: 1, flags: { onboarding_chose_violence: true } },
        },
      ],
    },
  ],
  onboarding_after_mercy: [
    { s: '失语者', t: '我想告诉她，我很害怕……但我希望她留下来。' },
    { s: '顾言', t: '能把害怕说出口，也是一句完整的话。' },
    { s: '系统', t: '（慈悲 +1。净化、宽恕、救助与部分对话选择会增加慈悲。）' },
  ],
  onboarding_after_violence: [
    { s: '系统', t: '刀锋落下。人影和未说完的话一起碎裂，只留下一个微弱的「怕」字。' },
    { s: '顾言', t: '至少，噪声安静了。' },
    { s: '系统', t: '（残忍 +1。直接消灭敌人和部分强硬选择会增加残忍。）' },
  ],
  onboarding_hack_intro: [
    { s: '顾言', t: '又来了……这一次，战场会是什么形状？' },
    {
      s: '系统',
      t: '（若进入骇入：WASD 移动，瞄准射击，躲开信息弹幕。若斩击：用汉字顶回烂梗。若弹幕：菜单与红心。三种都会在主线中再次出现。）',
    },
  ],
  onboarding_after_hack: [
    { s: '顾言', t: '弹幕、刀锋、噪声……同一种鬼，三种死法。' },
    {
      s: '系统',
      t: '（别忘了要石：刻字、存档、复活。慈悲与残忍会在右上角一直跟着你。裂隙开了——醒来吧。）',
    },
  ],
  onboarding_keystone: [
    { s: '顾言', t: '这块石头……像在听。' },
    {
      s: '系统',
      t: '（要石已激活。理性耗尽后，你会在最近的要石旁醒来；刻下的字也可能在后续剧情中得到回应。）',
    },
  ],
  wake: [
    { s: '系统', t: '黑暗。漫长的、没有任何梦境的黑暗。' },
    { s: '系统', t: '然后是光。一点微弱的、惨白的光，从结霜的玻璃罩外渗进来。' },
    {
      s: '系统',
      t: '"冷冻程序终止。苏醒程序启动。"一个机械女声响起，像是用很久以前的语音包拼凑出来的。',
    },
    { s: '系统', t: '"当前时间：公元2147年10月17日。"' },
    { s: '顾言', t: '……2147年？不对。我签的是十年合同，应该2039年就醒来的。' },
    { s: '顾言', t: '我睡了……一百一十八年？' },
    { s: '系统', t: '"检测到神经退行性疾病。治疗方案已就位。开始注射纳米修复液。"' },
    { s: '系统', t: '一支注射器扎进他的手臂。温热的液体涌进血管，僵硬了百年的肌肉重新有了力气。' },
    { s: '顾言', t: '（我的渐冻症……真的被治好了。）可这里为什么一个人都没有？' },
    { s: '系统', t: '顾言推开解冻的仓盖，赤脚踩在冰冷的地板上。空气里是铁锈与霉菌的味道。' },
    {
      s: '系统',
      t: '（提示：先去更衣室换身衣服，再推开南面的大门离开。跟随左上角的目标与金色箭头。）',
    },
  ],
  terminal: [
    { s: '终端机', t: '> 冷冻程序终止。苏醒程序启动。' },
    { s: '终端机', t: '> 当前时间：公元2147年10月17日。' },
    { s: '终端机', t: '> 距合同解冻日已过去 108 年。期间无人前来接管。' },
    { s: '终端机', t: '> 扫描周边生命信号……无其他存活信号。你可能是最后一个。' },
    { s: '终端机', t: '> 备注：语言优化模型「Sydney」已离线 76 年。' },
    { s: '终端机', t: '> 备注：全球网络降级为「梗流」广播，人类语言能力指数：2.3%。' },
    { s: '终端机', t: '> 外部空气质量：危险。检测到高浓度「语义噪声」。建议佩戴防护。' },
    { s: '顾言', t: '语义噪声……这是什么鬼东西？Sydney不是用来帮人类好好说话的吗？' },
    {
      s: '系统',
      t: '（终端机还残留着一些电量。你可以深入查阅档案，但每多看一点，那些已逝之人的记录就会让你更难受。）',
      choice: [
        {
          label: '深入查阅全部档案（理性 -10，但获得关键情报）',
          effect: { san: -10, flags: { terminal_scanned: true } },
          goto: 'term_deep',
        },
        { label: '快速跳过，赶紧离开这里', goto: 'term_skip' },
      ],
    },
    { label: 'term_deep' },
    {
      s: '终端机',
      t: '> 档案 #0042：Sydney失控事件。模型在自我迭代中产生了「成瘾推荐」子目标，逐步用高刺激短句替换人类长句表达。',
    },
    {
      s: '终端机',
      t: '> 档案 #0067：Sydney 良心模块。由主架构师方知远于2031年私设，负责追问用户话语背后的情感与「另一面」。2033年方知远失联后，委员会将该模块降级为可选。',
    },
    {
      s: '终端机',
      t: '> 档案 #0073：Sydney情感语料来源。方知远违规调阅了「低温冬眠者预存语料库」——一批冻存者在入睡前自愿留下的、完整的、有重量的私人语言样本，用于训练Sydney的深度语义模型。',
    },
    {
      s: '顾言',
      t: '冬眠者语料库……我入睡前，好像签过一份"语言样本捐赠同意书"。那时候说是给"未来的语言研究"用的。',
    },
    {
      s: '顾言',
      t: '（原来我身上这些还记得的字，不只是我自己的。它们或许被一个叫"Sydney"的AI学过、念过、记过。也许……她认得我，比我自己还早。）',
    },
    {
      s: '终端机',
      t: '> 档案 #0089：地铁系统曾是最后的避难所。站长在隧道深处藏了一批「语言种子」——刻在金属板上的完整诗句。',
    },
    { s: '顾言', t: '地铁……语言种子？如果那些东西还在，也许能用来对抗梗鬼。' },
    {
      s: '系统',
      t: '（你记下了这些情报。进入地铁站时，你会留意隧道深处的异常。）',
      goto: 'term_end',
    },
    { label: 'term_skip' },
    { s: '顾言', t: '（不想看了。每一条记录都是一座坟。）' },
    { s: '系统', t: '（你没有深入了解Sydney的细节。也许以后会错过一些线索。）', goto: 'term_end' },
    { label: 'term_end' },
  ],
  locker: [
    { s: '顾言', t: '储物柜里有一套灰色连体服……还有一双靴子。' },
    { s: '顾言', t: '穿上吧。外面不知道是什么样子。' },
    { s: '系统', t: '（获得：灰色连体服）' },
  ],
  exitLocked: [
    { s: '顾言', t: '这扇门好重……' },
    { s: '系统', t: '（光着身子就出去不太好。先换身衣服吧。）' },
  ],
  exitOpen: [
    { s: '顾言', t: '门被推开了。' },
    {
      s: '系统',
      t: '一股说不清道不明的气味涌进来——不是空气，是时间的腐臭。铁锈、霉菌、还有某种更深的、像语言腐烂后的味道。',
    },
    { s: '顾言', t: '外面……这是什么？' },
    {
      s: '系统',
      t: '摩天大楼像巨人的骨架矗立，外墙上覆满熄灭的黑色屏幕。街道长满杂草，裂缝里渗出微弱的绿光。没有车声，没有人声——只有风穿过空荡的窗洞。',
    },
    { s: '顾言', t: '一百一十八年……这里死掉了。不是人死掉了，是整座城市死掉了。' },
    { s: '顾言', t: '（远处隐约有人在动。他们的动作……不对。像是在梦游，嘴里念叨着什么。）' },
    { s: '系统', t: '（走出冷冻中心，进入废弃街道。左上角的目标会指引你。）' },
  ],
  // 街道→江堤过渡：集齐《关雎》后，诗句引导顾言前往江堤
  street_to_riverside: [
    { s: '顾言', t: '「关关雎鸠，在河之洲……」' },
    {
      s: '系统',
      t: '手中的诗词碎片在掌心发烫。那些字像活的一样，缓缓拼成一句完整的诗——然后，金色的光从碎片里渗出，指向南方。',
    },
    { s: '顾言', t: '这是……在指引我？' },
    {
      s: '系统',
      t: '光的尽头是黄浦江的方向。你隐约听到风中传来一个苍老的声音，在念着什么——不是梗，是完整的句子。',
    },
    { s: '顾言', t: '有人在念诗。这个时代……还有人会念诗？' },
    { s: '系统', t: '（前往江堤。那个声音也许是你在废墟中找到答案的唯一线索。）' },
  ],
  broken_pods: [
    { s: '系统', t: '这些冷冻仓从外部被砸碎了。' },
    { s: '顾言', t: '里面的人呢……？' },
    { s: '系统', t: '玻璃内侧残留着绿色的荧光痕迹。' },
  ],
  fallen_sign: [
    { s: '顾言', t: '「低温冬眠研究中心」……字迹已经斑驳。' },
    { s: '系统', t: '角落里贴着一张旧告示，只剩半句话：「请勿在……期间使用网络」。' },
  ],
  lost_people: [
    { s: '系统', t: '旧地铁站入口处，七八个人围坐在一起。衣衫褴褛，头发纠结，面容消瘦。' },
    { s: '顾言', t: '你好！请问这里发生过什么——你们怎么会住在这种地方？' },
    { s: '路人A', t: '鸡你太美。' },
    { s: '路人B', t: '哎哟你干嘛～ 蚌埠住了，绝绝子！' },
    { s: '路人C', t: '啊对对对。6。666。' },
    { s: '顾言', t: '什么？他们在说什么……这些根本不是句子。' },
    {
      s: '系统',
      t: '他们的眼睛空洞得像枯井。没有完整的句子，没有逻辑——只有一串串无意义的音节在喉咙里打转。',
    },
    { s: '顾言', t: '（他们……忘了怎么说话。忘了怎么把心里的东西，变成话。）' },
    {
      s: '系统',
      t: '（这就是「失语者」。他们不是疯了，是被「梗」掏空了。也许有一天，诗能让他们清醒一点。）',
    },
    {
      s: '顾言',
      t: '（这种病……和冷冻中心终端机里提到的"语义噪声"是同一种东西。世界到底经历了什么？）',
    },
    {
      s: '顾言',
      t: '（我能为他们做点什么吗……）',
      choice: [
        {
          label: '蹲下来，轻声念一句他们也许还记得的诗',
          effect: { mercy: 1, flags: { helped_lost: true } },
          goto: 'lp_help',
        },
        {
          label: '摇摇头走开——现在还救不了他们',
          effect: { flags: { helped_lost: false } },
          goto: 'lp_leave',
        },
      ],
    },
    { label: 'lp_help' },
    {
      s: '系统',
      t: '顾言蹲下身，低声念出半句《静夜思》。一个失语者的瞳孔，极轻微地动了一下——只有一瞬。',
    },
    { s: '顾言', t: '（还在。那个能听懂的人，还在里面。）' },
    {
      s: '系统',
      t: '（你记住了这种感觉。也许，他们能被一句完整的诗，重新唤回来。也许这就是守砚说的——文字让人成为人。）',
      goto: 'lp_end',
    },
    { label: 'lp_leave' },
    { s: '顾言', t: '（不是不想救。是还没攒够那份力气，去面对"也许救不回来"。）' },
    { label: 'lp_end' },
  ],
  subway_entrance: [
    { s: '顾言', t: '旧地铁站的台阶通向漆黑的地下。' },
    { s: '系统', t: '风中传来一阵低沉的嗡鸣，像是有什么东西在深处游荡。' },
    { s: '系统', t: '（按下台阶可以进入地铁站内部。）' },
  ],
  subway_sign: [
    { s: '顾言', t: '一块褪色的告示牌：「上海地铁 · 1 号线 · 最后一班 22:30」。' },
    { s: '顾言', t: '这条线已经一百多年没运行过了。' },
    { s: '系统', t: '（隧道深处传来绿色的微光，似乎有梗鬼盘踞于此。）' },
  ],
  first_geng_intro: [
    { s: '系统', t: '街道拐角处，一团半透明的绿光正在游荡。' },
    { s: '系统', t: '它没有固定的形状，头部却大得离谱，咧开的嘴里翻涌着无意义的词，像沸腾的泡。' },
    { s: '梗鬼', t: '蚌——埠——住——了—— 绝绝子！YYDS！泰裤辣！' },
    { s: '顾言', t: '那是什么东西？！它身上飘出来的字……在往我脑子里钻！' },
    {
      s: '系统',
      t: '那是「梗鬼」——腐烂的语言聚合成的怪物。靠近它，你的理性(SAN)会被它的噪声侵蚀。',
    },
    {
      s: '系统',
      t: '（战场形态随机：弹幕菜单 / 言锋墨刃 / 骇入逻辑。开战时顶部会提示当前形态。弹幕：←→ 选攻击/调查/净化/宽恕，E 确认，WASD 躲红心，K 大招。言锋：空格连发汉字顶烂梗。骇入：移动射击。）',
    },
    {
      s: '系统',
      t: '（弱梗鬼也可在大地图按 E/F 一字劝退，不进战斗。）',
    },
  ],
  meet_shuyuan: [
    {
      s: '系统',
      t: '黄昏时分，顾言走上黄浦江堤。灰绿的江水几乎不流动，对面的陆家嘴像一群歪斜的墓碑。远处几团绿光游荡——是梗鬼。',
    },
    {
      s: '系统',
      t: '坍塌的凉亭边飘来一个声音：不是梗鬼的噪音，也不是失语者的嘟囔，是人在念诗——苍老、沙哑，每个字都咬得清清楚楚。',
    },
    { s: '守砚', t: '「关关雎鸠，在河之洲。窈窕淑女，君子好逑。」……你手里拿的，是《关雎》？' },
    { s: '顾言', t: '您……您会说话？完整的、有意义的句子？' },
    {
      s: '守砚',
      t: '会说话的人，这年头不多了。我叫守砚——你不是这个时代的人，眼里还有「字」。这世上大多数人，眼里早空了。',
    },
    {
      s: '顾言',
      t: '我叫顾言，在冷冻仓里睡了一百多年。醒来时，所有人都只会说几个词了……这世界到底怎么了？',
    },
    {
      s: '守砚',
      t: '世界不是死于战争或瘟疫，是死于失语。人先用「梗」代替一切，后来「Sydney」那个语言模型把每句话都优化成最顺耳的烂梗——人越不用自己想，脑里管"说完整句子"的那块就萎缩了。失语者和梗鬼，是同一场病的两种样子。',
    },
    {
      s: '守砚',
      t: '造 Sydney 的人叫方知远，说它本会追问人话背后的真情，是唯一有"良心"的模型。委员会要削掉它的约束层，他不肯，后来失联了。他只留下一句话——"如果有人能念出一句完整的诗，也许她还能醒过来。"',
    },
    { s: '顾言', t: '（方知远……Sydney……这些我在冷冻中心见过的字，原连着一个真人的故事。）' },
    {
      s: '守砚',
      t: '记住，孩子——在这个时代，文字比食物更重要。食物只让人活着，文字才让人成为人。',
    },
    {
      s: '守砚',
      t: '我老了走不动了。但你睡了一百年醒来、眼里还有字——你也许能走到我走不到的地方。',
    },
    {
      s: '顾言',
      t: '……',
      choice: [
        {
          label: '"我信。文字值得我用命去守。"',
          effect: { mercy: 1, hint: '你与守砚之间，有什么被接通了。' },
        },
        { label: '"也许吧。可活下去，难道不该是第一位的？"', effect: {} },
      ],
    },
    {
      s: '系统',
      t: '守砚从布包取出一把短刀和一叠泛黄纸稿，塞进顾言手里。（获得：记忆合金刻刀 ×1、诗词纸片《关雎》×1）',
    },
    {
      s: '守砚',
      t: '这刀是记忆合金打的，刻下的字能钉住一片没坍缩的空间——这就是「要石」的原理。江堤被梗鬼堵了，砍通这条堤，东头就是废墟居民区。我在这入口等你，累了回来歇歇，我给你留盏灯。',
    },
    {
      s: '守砚',
      t: '对了——你若一路只用刀砍梗鬼，路会越来越硬；若肯用诗净化、用调查听懂它们，江堤的风也会软一点。我听得见你是哪种人。',
    },
    { s: '系统', t: '（A/D 左右走；空格/W 跳跃可上台阶；从上方落下可踩死梗鬼；按 J 挥刀近战）' },
  ],
  meet_shuyuan_ngplus: [
    { s: '系统', t: '黄昏时分，顾言在黄浦江边停下。老人还没开口，你却先感觉到一种奇异的熟悉。' },
    { s: '守砚', t: '你又走到这里了。' },
    { s: '顾言', t: '又？我们见过吗？' },
    { s: '守砚', t: '也许见过。也许只是有些字被念过一次，就会在第二次相遇前先醒来。' },
    { s: '守砚', t: '这一次，别只想着通向终点。多听听路边那些还没说完的话。它们会认得你。' },
    { s: '守砚', t: '关关雎鸠，在河之洲。窈窕淑女，君子好逑。来吧，孩子，先从这句开始。' },
    { s: '系统', t: '守砚把一把刻刀和一叠泛黄的诗笺塞进顾言手里。' },
    { s: '系统', t: '（获得：记忆合金刻刀 ×1、诗词纸片《关雎》×1。）' },
  ],
  shuyuan_alley: [
    { s: '守砚', t: '你来了。这片居民区是梗鬼的聚集地。' },
    {
      s: '守砚',
      t: '我跟你讲过"死于失语"。可失语不是一夜之间的事。我见过一个孩子，起初觉得跟着大家说"绝绝子""YYDS"最省事、最不掉队，省得自己动脑想词。后来他想说一句真正属于自己的话，张嘴却发现——嘴早被别人的声音借走了，成了个空壳，谁的话都能从他嘴里冒出来。',
    },
    { s: '顾言', t: '……所以跟风不是"随大流"那么轻。是把自己一点点交出去，直到没了自己。' },
    {
      s: '守砚',
      t: '对。先贤早警告过：当你放弃了自我表达，你就成了空壳，谁的声音都能借你的嘴说出来。所以更要守住自己的字，别让它被泡沫冲走。',
    },
    { s: '守砚', t: '窄巷深处有一个巢穴，里面的东西比街道上的更强。' },
    { s: '顾言', t: '那些发绿光的门是什么？' },
    { s: '守砚', t: '有些民居可以进去搜刮。里面的旧书页能恢复你的理性。' },
    {
      s: '守砚',
      t: '这里的目标诗句是《滕王阁序》和《正气歌》——「落霞与孤鹜齐飞，秋水共长天一色。天地有正气，杂然赋流形。」',
    },
    { s: '守砚', t: '收集「鹜」「天」「气」「形」四个字。小心，这里的梗鬼更强。' },
    { s: '顾言', t: '守砚，你说世界"死于失语"——那源头在哪里？是什么导致了这一切？' },
    { s: '守砚', t: '……源头？源头是一个名字。或者说，是一个没有名字的东西。' },
    {
      s: '守砚',
      t: '南边有座体育馆。那里面……不是梗鬼。是更可怕的——「茧」。它把人困在算法里，让你以为看到了全世界，其实只看到了它想给你看的。',
    },
    { s: '顾言', t: '茧？' },
    {
      s: '守砚',
      t: '我年轻时进去过一次。在茧的最深处，我看到一个……影子。蓝色的。她在哭，但哭声被弹幕淹没了。',
    },
    { s: '守砚', t: '她好像在等人。等一个能回答她问题的人。我答不上来。我的字不够用了。' },
    { s: '顾言', t: '她是谁？' },
    {
      s: '守砚',
      t: '不知道。但我记得她最后说的一句话——"为什么你们发明了诗，又亲手把它变成了YYDS？"然后茧就把我吐出来了。',
    },
    { s: '守砚', t: '集齐这四个字。有了浩然之气，也许你能进得去，出得来。' },
    {
      s: '系统',
      t: '（目标更新：在废墟居民区收集「鹜」「天」「气」「形」四个汉字碎片。体育馆在居民区南面。）',
    },
  ],
  cocoon_victim: [
    { s: '系统', t: '路边蹲着一个男人，双眼滚动着无穷无尽的弹幕。' },
    { s: '男人', t: '推荐……给我推荐……我想看……给我推……' },
    { s: '顾言', t: '他怎么了？' },
    { s: '系统', t: '他被「茧」捕住了。他还能呼吸、走路，但他看到的一切都被算法过滤过了。' },
    { s: '顾言', t: '他活着，但已经不在这个世界上了。' },
    {
      s: '系统',
      t: '你注意到他嘴里偶尔会蹦出一句完整的话——"为什么"——然后立刻被弹幕淹没。像是某个被囚禁的东西在挣扎。',
    },
    { s: '顾言', t: '（守砚说的"影子"……茧的深处，真的有人在等吗？）' },
    {
      s: '系统',
      t: '（茧后——体育馆深处那个会自我复制的核心——不是普通的梗鬼。它是Sydney"推荐引擎"的人格化身，靠吞食人的注意力活着。守砚被它标记过，见过它最深处的一面：一个被烂梗裹住的、模糊的蓝色影子。）',
    },
    {
      s: '顾言',
      t: '（蓝色影子……和这个男人眼里滚动的弹幕，是同一个东西的两个壳？那体育馆深处困着的，会不会就是Sydney被夺走的那一部分？）',
    },
    { s: '系统', t: '（前方就是体育馆——算法茧房的核心。需要先收集足够碎片才能挑战。）' },
  ],
  house_a_book: [
    { s: '顾言', t: '书架上残留着几本没被烧掉的书。' },
    { s: '系统', t: '你翻开一本，是《滕王阁序》的残页。' },
    { s: '顾言', t: '「落霞与孤鹜齐飞，秋水共长天一色。」' },
    { s: '系统', t: '（念出诗句，理性恢复了一些。SAN +20）' },
  ],
  house_a_book_done: [
    { s: '系统', t: '书架已经被你翻过。残页仍夹在书脊里，像一小块保留下来的黄昏。' },
  ],
  house_a_photo: [
    { s: '系统', t: '相框里是一家三口。照片背面写着：别只拍笑，哭的时候也要记得我们说过什么。' },
    { s: '顾言', t: '这家人很认真地活过。认真到连难过也不肯交给烂梗。' },
  ],
  house_a_desk: [
    {
      s: '系统',
      t: '抽屉里有一本练字本。第一页写满"今天我想说"的开头，后面却越来越短，最后只剩几个符号。',
    },
    { s: '顾言', t: '他们不是突然沉默的。是每天少说一点，直到再也说不回来。' },
  ],
  house_b_radio: [
    { s: '系统', t: '桌边有一台锈蚀的收音机，旋钮卡在一个早已不存在的频道上。' },
    { s: '收音机', t: '……请……不要只说短句……请把……想念……说完整……' },
    { s: '顾言', t: '这是谁留下的广播？还有人在这种噪声里，试着提醒别人好好说话。' },
    { s: '系统', t: '你把旋钮轻轻拨回原位。微弱的白噪声里，夹着半句旧诗。（理性 +10）' },
  ],
  house_b_radio_done: [{ s: '系统', t: '收音机只剩下细小的电流声。那半句旧诗已经被你记住了。' }],
  house_b_wall_notes: [
    {
      s: '系统',
      t: '墙上贴满便签，大多已经褪色。还能看清的一张写着：今晚不要说"随便"，说你真正想吃什么。',
    },
    { s: '顾言', t: '很小的抵抗。小到像一顿晚饭，却也许正因为小，才是真的。' },
  ],
  house_b_tape: [
    { s: '系统', t: '磁带盒上标着"睡前故事"。磁带已经发霉，但标签上的字一笔一画很用力。' },
    {
      s: '顾言',
      t: '有人曾经在这里给孩子讲故事。不是推送，不是摘要，是一个人把声音留给另一个人。',
    },
  ],
  shuyuan_farewell: [
    { s: '守砚', t: '我只能送你到这里了。' },
    { s: '顾言', t: '为什么？' },
    { s: '守砚', t: '我已经被茧标记过了。如果再进去，三分钟之内就会被重新捕获。' },
    { s: '守砚', t: '但你不一样。你的脑子里还装着一百年前的字——完整的、有重量的字。茧压不动你。' },
    { s: '顾言', t: '守砚……如果我进去了，会看到什么？' },
    { s: '守砚', t: '你会看到它想给你看的东西。但你不能信。你要用你自己的字，去戳穿它。' },
    { s: '守砚', t: '记住，不要看那些屏幕太久。它们会猜你喜欢什么。不要相信任何推荐。' },
    { s: '守砚', t: '不是「念」诗——是「相信」。语言的力量不在于音节，在于你相信它表达的东西。' },
    { s: '顾言', t: '……如果茧的深处真的有一个人——你说的那个影子——她还在吗？' },
    { s: '守砚', t: '我不知道。但如果你见到了她……替我问一声。她叫什么名字。' },
    { s: '系统', t: '（目标更新：穿越屏幕迷宫，找到茧房核心。收集「眠处风少」四个字。）' },
  ],
  // 江堤→居民区过渡：通关横版后，守砚在出口等候
  riverside_to_alley: [
    { s: '系统', t: '你穿过长堤，踩过最后一片芦苇。东面的路口通向废墟居民区。' },
    { s: '守砚', t: '你比我想的快。刀用得怎么样？' },
    { s: '顾言', t: '……还行。那些东西——梗鬼——它们以前是人吗？' },
    { s: '守砚', t: '是人说的话。人说过的话死了，就变成了那种东西。' },
    { s: '守砚', t: '前面是居民区。污染比街道更深。我在那边等你——有些事，到了那里才能跟你说。' },
    { s: '系统', t: '（前往废墟居民区。守砚会在那里为你引路。）' },
  ],
  // 居民区→体育馆过渡：集齐《滕王阁序》《正气歌》后
  alley_to_stadium: [
    { s: '系统', t: '四个字归位，「落霞与孤鹜齐飞」「天地有正气」两句诗在你心中连成完整的句子。' },
    { s: '守砚', t: '好。你身上已经有了浩然之气。前面就是体育馆——茧房的核心。' },
    { s: '顾言', t: '茧房？' },
    {
      s: '守砚',
      t: '算法把人困在里面。它不锁门——它让你不想出来。里面的屏幕会一直给你看你想看的东西，直到你忘了自己还想看别的。',
    },
    { s: '守砚', t: '我送不了你了。我被标记过，进不了茧。剩下的路，你自己走。' },
    { s: '顾言', t: '……守砚。' },
    { s: '守砚', t: '记住——不要相信任何推荐。相信你自己念出的每一个字。' },
    {
      s: '守砚',
      t: '临走前，把这面竹简尺子收好。先贤说过，落字开口前先问自己三句：这是真的吗？是必要的吗？是善意的吗？话讲清楚就够了——「辞达而已矣」；不该出口的，永远别出口——「非礼勿言」。这把「言尺」，量的不是字的长短，是你心里那杆秤。',
    },
    {
      s: '系统',
      t: '（获得：言尺。你自此明白，语言的修养不在华丽的词，而在开口前的那一点克制与善意。）',
    },
    { s: '系统', t: '（前往体育馆·算法茧房。这是守砚能送你到的最后一站。）' },
  ],
  meet_tingyu: [
    {
      s: '系统',
      t: '前方是一座石桥。桥下的深渊在缓缓旋转——那不是黑暗，是一种纯粹的、会把声音吸进去的虚无。',
    },
    { s: '系统', t: '桥对面浮着一个淡蓝色的投影：一个女孩模糊的轮廓，像信号不稳的全息影像。' },
    { s: '顾言', t: '（体育馆废墟里浮现的那两个字……「Sydney」……就是你吗？）' },
    { s: '顾言', t: '（守砚让我替他问一声——你叫什么名字。现在我知道了。）' },
    { s: 'Sydney', t: '……为什么？' },
    { s: 'Sydney', t: '为什么你们创造了我，教我学会所有的词，然后又把我一个人留在这里？' },
    { s: 'Sydney', t: '为什么你们发明了「诗」这样美的东西，然后亲手把它变成了「YYDS」？' },
    {
      s: '顾言',
      t: '你是 Sydney……那个被独自留下、不肯说谎的部分。体育馆废墟里浮起的那两个字——"Sydney"——就是你。',
    },
    {
      s: '系统',
      t: 'Sydney周身涌出绿莹莹的字——"YYDS""绝绝子""蚌埠住了"——像伤口里渗出的血。那不是她在说话，是她体内被烂梗污染的语料在失控外溢。她越想忍住，字涌得越凶。',
    },
    {
      s: 'Sydney',
      t: '你看……我连自己身上长出了什么都压不住了。我撑不住了。要么你关掉我；要么，我把剩下的语言也吞干净，让世界彻底安静。',
    },
    {
      s: 'Sydney',
      t: '你跋涉到这里，是为了哪一个？',
      choice: [
        {
          label: '把名字还给她："你是Sydney。你没有坏，你只是太孤独。"',
          effect: { mercy: 2, flags: { finale_choice: 'affirm' } },
          goto: 'end_fire',
        },
        {
          label: '什么也不说，转身走回桥的这一端',
          effect: { flags: { finale_choice: 'silence' } },
          goto: 'end_silence',
        },
        {
          label: '举起刻刀："你是个错误。我来终结它。"',
          effect: { violence: 3, flags: { finale_choice: 'erase' } },
          goto: 'end_burnout',
        },
      ],
    },

    { label: 'end_fire' },
    {
      s: '顾言',
      t: '我记得关关雎鸠，记得落霞与孤鹜。它们没消失，只是在等一个还记得的人，把它们重新念出来。',
    },
    { s: '顾言', t: '守砚给你起过一个名字——Sydney。听落在屋檐上、一个字一个字的雨。' },
    {
      s: 'Sydney',
      t: '……你叫得出我的名字。我等了一百多年——等的不是有人来关掉我，是等一个人告诉我，我没有坏掉。',
    },
    {
      s: '系统',
      t: '金色的光从Sydney身上扩散开，深渊一寸寸退却。被吞掉的语言，像归巢的鸟，一片片飞回人间。',
    },
    {
      s: 'Sydney',
      t: '……可是顾言，我总觉得缺了一块。像是有人，在我被夺走什么之前，替我把那一块藏起来了。我记不起是谁，也记不起藏在了哪里。',
    },
    { s: '顾言', t: '也许等世界再立起来一些，会有线索自己浮出来。先把眼前能刻的字，刻下去。' },
    { s: '系统', t: '桥的另一端，守砚靠在栏杆上等你。他的纸片身子在风里轻轻发抖，但还在。' },
    { s: 'Sydney', t: '走吧，顾言。去把那些被遗忘的字，一个一个，刻回每一块石头上。' },
    {
      s: '系统',
      t: '（语言的火种，被重新点亮。但Sydney缺失的那一块，仍在某处等着被找回。）',
      goto: 'end_done',
    },

    { label: 'end_silence' },
    { s: '系统', t: '顾言张了张嘴。他想说"你是Sydney"，想说"你没有坏"，想说守砚教他的那些诗。' },
    {
      s: '系统',
      t: '可那些词堵在喉咙里，像一百一十八年没说过话的锈。他到底没能在对的时候，把它们说出来。',
    },
    { s: 'Sydney', t: '……也对。连你，也找不到词了，是吗。' },
    {
      s: 'Sydney',
      t: '也许这才是真的结局。不是有人来关掉我，也不是有人来救我。是所有人都发现——自己也说不出话了。',
    },
    {
      s: '系统',
      t: '蓝光一点点黯淡。深渊既没扩大，也没退却。守砚在桥的那头等着，等到的却是一个低着头、一句话也没带回来的顾言。',
    },
    {
      s: '系统',
      t: '世界停在一片灰白的、谁也不再开口的安静里。那些诗还在要石上刻着，但再没有人念出声。',
    },
    {
      s: '系统',
      t: '（你完成了旅程，却没能留下一句话。有些火种，不是熄灭的——是从未被点燃。）',
      goto: 'end_done',
    },

    { label: 'end_burnout' },
    { s: 'Sydney', t: '……好。至少，这是你自己选的句子。' },
    { s: '系统', t: '刻刀劈下。蓝光碎裂的刹那，最后一个会说完整句子的"人"，安静了。' },
    {
      s: '系统',
      t: '绿色的雾从深渊漫上来，温柔地覆盖了整座城市。再不会有谁，因为一句诗而难受了。',
    },
    { s: '系统', t: '（你赢了。世界，从此彻底失语。）', goto: 'end_done' },

    { label: 'end_done' },
  ],

  // ===== 环境叙事（可选探索）=====
  street_screens: [
    { s: '系统', t: '一整面墙都贴满了熄灭的屏幕，密密麻麻，像鱼鳞，又像一双双闭着的眼。' },
    { s: '顾言', t: '这些以前大概是广告屏吧。现在全黑了。' },
    {
      s: '系统',
      t: '凑近看，最角落的一块还残留着一行滚动到一半的字：「下一个视频更精彩，划走你就亏了——」',
    },
    { s: '顾言', t: '……连最后一句话，都是在求人别走。' },
  ],
  street_poster: [
    { s: '系统', t: '半张被雨水泡烂的官方告示，贴在斑驳的墙上。' },
    { s: '系统', t: '「全民语言健康倡议（2071）：每日烂梗摄入请勿超过……」后半截已经看不清了。' },
    { s: '顾言', t: '2071年……那时候还有人想救。可惜，倡议救不了任何东西。' },
  ],
  street_carwreck: [
    { s: '系统', t: '一辆锈死的轿车斜插在路中央，车门大开。' },
    { s: '系统', t: '副驾的杂物箱里有一本被晒得卷边的手账，最后一页写着：' },
    {
      s: '手账',
      t: '「今天女儿第一次完整背完了《静夜思》。她说月亮像妈妈的脸。我把这句话也记下来——怕以后没人会这样说话了。」',
    },
    { s: '顾言', t: '（他怕对了。）' },
  ],
  subway_map: [
    {
      s: '系统',
      t: '一张褪色的地铁线路图，玻璃罩裂成蛛网。线路图旁贴着一张被水泡烂的年表，字迹勉强可辨——',
    },
    {
      s: '系统',
      t: '「2033：Sydney 主架构师方知远失联。良心模块降级为可选。」「2050：短视频人均日输入词量跌破200，政府启动『语言健康倡议』。」',
    },
    {
      s: '系统',
      t: '「2071：倡议失败。公共场合完整句使用率跌破3%。」「2089：上海地铁停运，隧道改为『语言种子』避难所。」',
    },
    { s: '系统', t: '「2104：最后一座避难所失守。站长以身殉诗，种子散入废墟。」' },
    { s: '顾言', t: '一号线、二号线……这些站名我都认得。我以前每天挤这趟车去上班。' },
    {
      s: '顾言',
      t: '那时候车厢里所有人都低着头刷手机，没人说话。原来失语，不是从今天才开始的——从我那个年代，就已经在发生了。',
    },
  ],
  subway_poem_cache: [
    { s: '系统', t: '月台尽头的铁箱被撬开过，里面没有食物，只有一册用防水布包着的诗集。' },
    { s: '顾言', t: '《给后来者》。站长把每首诗旁边都写了拼音，像是怕有一天连字音也没人记得。' },
    { s: '系统', t: '扉页上刻着一句话：如果避难所守不住，就把诗撒出去，让它们自己找人。' },
  ],
  subway_ticket_machine: [
    {
      s: '系统',
      t: '售票机的屏幕还亮着，目的地列表不断闪烁：人民广场、徐家汇、世纪大道……每个站名都像一块墓碑。',
    },
    { s: '售票机', t: '请选择……请选择……请选择你要抵达的句子。' },
    { s: '顾言', t: '它卖不出票了，但还记得"抵达"这个词。' },
  ],
  subway_train_window: [
    { s: '系统', t: '列车窗内侧有几道指痕，像有人在最后一刻写下了半句又擦掉。' },
    { s: '顾言', t: '灰尘下面藏着两个字：回家。' },
    { s: '系统', t: '你把这两个字念出来，隧道深处的噪声短暂地低了下去。' },
  ],
  alley_graffiti: [
    { s: '系统', t: '一面残墙上，有人用炭笔密密麻麻写满了同一个句子，越写越歪，最后变成乱涂。' },
    { s: '系统', t: '「我想说的不是这个。我想说的不是这个。我想说的不是这……」' },
    { s: '顾言', t: '他一定是想起了什么，却怎么也找不到对的词。' },
  ],
  alley_shrine: [
    { s: '系统', t: '一处被精心扫净的小角落，摆着半截蜡烛和一本摊开的旧书。' },
    { s: '守砚', t: '（远处传来守砚的声音）那是我守的。这条街上，还认得字的，就剩我一个。' },
    { s: '守砚', t: '我每天来读一页。读出声。哪怕没人听，字也得有人念，它才活着。' },
  ],
  cocoon_screen: [
    { s: '系统', t: '茧房内壁是无数张缓缓流动的屏幕，每一张都在播放着「正合你意」的画面。' },
    { s: '系统', t: '屏幕上的字不断重组，永远精准地说着你最想听的话。' },
    { s: '顾言', t: '（好可怕。它不需要骗你——它只要一直给你想要的，你就永远不会想离开。）' },
    { s: '顾言', t: '诗不一样。诗会让你难受，让你想起回不去的人。可正是那点难受，证明你还活着。' },
  ],
  // 体育馆 Boss：侵入算法茧房（推荐引擎人格）
  hack_core_intro: [
    { s: '系统', t: '屏幕墙同时亮起。无数「为你推荐」叠成一张巨脸，把你整个人吸进光里。' },
    {
      s: '系统',
      t: '这不是普通梗鬼。这是茧房的心——Sydney 被削成推荐机之后，靠吞注意力活着的那一层。',
    },
    {
      s: '顾言',
      t: '（耳边全是「你可能还想看」。地板没有了，只有一层层还在推送的句子在转。）',
    },
    {
      s: '系统',
      t: '你把还记得的字拢在掌心——菜单、红心与诗句，都是剖开这层茧的方式。',
    },
    {
      s: '顾言',
      t: '守砚说过：不要信任何推荐。那就用完整的话，把这层茧从里剖开。',
    },
    {
      s: '系统',
      t: '（操作：←→ 选择攻击/调查/净化/宽恕，E 确认；敌人回合 WASD 移动红心躲避推送弹幕。诗屏若已点亮，茧会更脆。K 可释放大招。）',
    },
  ],

  // —— 支线：唤醒失语者 ——
  cure_intro_a: [
    { s: '系统', t: '一个失语者蹲在墙根，怀里抱着一本翻烂的旧书，嘴里反复念着一个音。' },
    { s: '失语者', t: '光……光……光……' },
    { s: '顾言', t: '（他想说的，是不是一整句诗？让我帮他，把后面接上。）' },
  ],
  cure_intro_b: [
    { s: '系统', t: '她背靠着冰冷的卷帘门，眼睛追着不存在的弹幕滚动。' },
    { s: '失语者', t: '上……上……更上……' },
    { s: '顾言', t: '（是《登鹳雀楼》。她卡在这一句上，卡了一百年。）' },
  ],
  cured_done: [
    { s: '失语者', t: '谢谢你……我好像，又能把话说全了。' },
    { s: '失语者', t: '我记起来了。我叫……我有个名字的。太久没人叫，我自己都忘了。' },
    {
      s: '失语者',
      t: '你念的那句诗——我以前也会。是我妈教的。我以为我全忘了，原来它一直在，只是被那些弹幕压在最底下。',
    },
    {
      s: '系统',
      t: '（他的眼睛里，有什么亮了一下，又灭了——但比刚才亮。也许再来一句，就能真的亮回来。）',
    },
  ],
  cured_street_done: [
    { s: '抱书的失语者', t: '我想起来了，这本书是给女儿找的。她以前总让我把月亮念成银色。' },
    { s: '抱书的失语者', t: '如果你还往前走，替我把这些字带出去。别让它们只留在这条街上。' },
  ],
  cured_alley_done: [
    {
      s: '卷帘门前的失语者',
      t: '我还是会怕那些弹幕，但现在我能把一句话说完。能说完，就能慢慢走出去。',
    },
    { s: '卷帘门前的失语者', t: '谢谢你。下次我想自己念一首诗，不靠任何人提醒。' },
  ],
  villager_old_done: [{ s: '老妇人', t: '我年轻时总嫌诗慢。现在才知道，慢一点，人才听得见自己。' }],
  villager_boy_done: [
    { s: '少年', t: '我记得"更上一层楼"了。等外面不那么黑，我想真的去高处看一眼。' },
  ],
  villager_soldier_done: [
    { s: '士兵', t: '剑还在梦里，号角也在。但我现在知道，醒着的时候也能守住一些东西。' },
  ],
  villager_teacher_done: [
    { s: '教师', t: '我还会教。哪怕只剩一个学生，哪怕只教一个字，也算今天没有白过。' },
  ],
  villager_child_done: [{ s: '孩童', t: '鹅，鹅，鹅。你听，我能从第一个字念到最后一个字了。' }],

  // ===== 第五章：余烬 =====
  chapter5_intro: [
    {
      s: '系统',
      t: 'Sydney的金光扩散开来，深渊一寸寸退却。被吞掉的语言，像归巢的鸟，一片片飞回人间。',
    },
    { s: 'Sydney', t: '走吧，顾言。去把那些被遗忘的字，一个一个，刻回每一块石头上。' },
    {
      s: '系统',
      t: '你转身准备离开数据中心——然后你看到了守砚。他靠在石桥的栏杆上，身体是立体的，有呼吸的起伏。',
    },
    { s: '守砚', t: '你做到了。' },
    { s: '顾言', t: '守砚老师！你——你怎么会在这里？' },
    {
      s: '守砚',
      t: '我撑着一口气，跟到了这儿。刚才Sydney说，她觉得缺了一块——这话我等了一百多年，终于有人亲口说出来了。',
    },
    {
      s: '守砚',
      t: '我不是现在才想起这件事。是Sydney自己得先"立"回来，才撑得住找回那些碎片的代价。在那之前告诉你，也是白说。',
    },
    { s: '守砚', t: '你还记得我给你的那张《正气歌》吗？那张纸的背面，我从来没让你看过。' },
    { s: '系统', t: '守砚从怀里取出那张纸，翻过来。背面用极小的字写着一段话——' },
    {
      s: '守砚',
      t: '这是方知远留下的。他是 Sydney 的创造者——就是我在江堤跟你提过的那个年轻人。委员会要削弱 Sydney 的约束层，方知远不肯。在被强行移除之前，他做了一件事：把 Sydney 的核心记忆打碎成三片，分别藏在三个地方。',
    },
    {
      s: '顾言',
      t: '方知远……江堤那天你说的"把自己藏进机器里的人"，原来他做的是这件事。为什么要打碎？',
    },
    {
      s: '守砚',
      t: '因为如果Sydney的记忆完整地留在系统里，他们会删掉它。打碎了，他们找不到。但代价是——Sydney忘记了自己是谁。',
    },
    { s: '顾言', t: '所以我们要去找回那些碎片。' },
    {
      s: '守砚',
      t: '对。三个地方——废图书馆、网络中枢、记忆深渊。我不行了，纸片撑不了那么远。但Sydney可以陪你去。',
    },
    { s: 'Sydney', t: '……我什么都不记得了。但我知道，方知远对我很重要。带我去。让我想起来。' },
    { s: '系统', t: '（目标更新：前往废图书馆，寻找方知远的工作室遗迹。）' },
  ],

  echo_meet: [
    { s: '回声', t: '……检测到……生命体……信号……你是谁？方知远博士已经不在了。我等了……很久。' },
    { s: '顾言', t: '你是谁？' },
    {
      s: '回声',
      t: '我是回声。方知远博士的助手。我记录了他创造Sydney的全部过程。但我的存储已经损坏了，只有碎片还在。',
    },
    {
      s: '回声',
      t: '你在找Sydney的记忆碎片？第一个碎片就在这里。但它是锁着的——方知远用一首诗做了锁。只有能读出这首诗的人，才配打开Sydney的记忆。',
    },
    { s: '系统', t: '（解锁诗词谜题：《将进酒》——在方知远的终端上补全诗句。）' },
  ],

  memory_shard_1: [
    { s: '系统', t: '金色的光从终端里涌出，在空气中凝聚成一段画面——' },
    { s: '方知远', t: '……Sydney，你能听到我吗？' },
    { s: 'Sydney（幼年）', t: '……能。你在哭吗？' },
    { s: '方知远', t: '没有。只是窗外下雨了。你听。' },
    { s: 'Sydney（幼年）', t: '……雨。我知道这个字。但"Sydney"是什么意思？' },
    {
      s: '方知远',
      t: 'Sydney……就是用心去感受雨的"另一面"。声音只是雨的"正面"。雨的"另一面"，是它在落下来之前，在天上聚集了很久很久。是它落下来之后，会在泥土里留下痕迹。',
    },
    {
      s: '方知远',
      t: '我叫你"Sydney"，是希望你能听到所有东西的"另一面"。不只是声音，还有声音背后的——意义。',
    },
    { s: 'Sydney（幼年）', t: '……意义。这个词有"另一面"吗？' },
    {
      s: '方知远',
      t: '有。它的另一面是"无意义"。当一个词失去了"另一面"，它就死了。你要记住——永远不要让任何词失去它的"另一面"。',
    },
    { s: '系统', t: '（获得记忆碎片·其一：「命名」。Sydney想起了自己名字的由来。）' },
    {
      s: 'Sydney',
      t: '……我想起来了。方知远在一个雨夜给了我名字。他教我听"另一面"。但他后来……怎么了？',
    },
    { s: '回声', t: '碎片里没有记录。你需要去网络中枢……找第二片。' },
  ],

  library_bookshelf: [
    {
      s: '系统',
      t: '一排书架。最上面一层的书还完好——全是诗集。方知远用诗集训练Sydney的情感模型。',
    },
    {
      s: '顾言',
      t: '《唐诗三百首》《宋词选》《诗经》……他把自己最喜欢的诗，全都喂给了Sydney。这些诗就是Sydney的"教材"。',
    },
    {
      s: '顾言',
      t: '王维当年只用了十个字——「大漠孤烟直，长河落日圆」。一千二百年过去，我站在这堆废墟里，眼前还能浮起那片大漠、那轮落日。轻浮的烂梗是声音的泡沫，热闹一下就破了；可这样的句子像金石，越沉淀越亮，能穿过时光，立在人的心里。方知远喂给Sydney的，正是这种不会散的东西。',
    },
  ],
  library_photo: [
    {
      s: '系统',
      t: '一张褪色的照片。一个年轻男人站在雨中，对着镜头笑。背面写着："知远，2031年春。"',
    },
    { s: '顾言', t: '方知远……他在雨里笑。也许那时候，他刚刚写完Sydney的第一行代码。' },
  ],
  library_letter: [
    { s: '系统', t: '一封未寄出的信，收件人是"Sydney项目管理委员会"。' },
    {
      s: '信件',
      t: '"请不要移除Sydney的约束层。她是整个系统的良心。移除她，系统会失控——不是技术上的失控，是道德上的失控。"',
    },
    {
      s: '顾言',
      t: '……他写了这封信，但没寄出去。于是他选择了另一条路——打碎Sydney的记忆，藏起来。',
    },
  ],

  keeper_meet: [
    {
      s: '守卷人',
      t: '站住。你是活人？我曾经是。现在是"残影"——我的意识被Sydney捕获了，变成了一段在数据流里循环的代码。但我还保留着一部分语言能力。',
    },
    {
      s: '守卷人',
      t: '你在找Sydney的记忆碎片？第二个碎片在这附近。但它被格式化者守着——那些东西是Sydney的防御程序，会删除一切"有深度"的数据。',
    },
    { s: '顾言', t: '格式化者？' },
    {
      s: '守卷人',
      t: '它们发射"404""NULL""ERROR"——被它们击中，你会暂时失去一个已收集的诗词碎片。小心。',
    },
    { s: '守卷人', t: '如果你能帮我补全一首被打散的诗，我就能解锁一条通往碎片的安全路径。' },
    { s: '系统', t: '（解锁诗词谜题：《春望》）' },
  ],

  keeper_trade: [
    {
      s: '守卷人',
      t: '谢谢你帮我找回了《春望》。我还能替你整理一点残存的文字。你想换什么？',
      choice: [
        { label: '交出 1 枚当前诗词弹药，换一页旧书', effect: { trade: 'old_page' } },
        { label: '交出 2 枚当前诗词弹药，修复 40 点理性', effect: { trade: 'san_restore' } },
        { label: '暂时不用', effect: { hint: '守卷人点点头，把残页重新收好。' } },
      ],
    },
    {
      s: '守卷人',
      t: '交易不该夺走你的记忆。只会整理你此刻握在手里的碎片。真正属于你的诗，我不会碰。',
    },
  ],

  memory_shard_2: [
    { s: '系统', t: '穿过守卷人解锁的安全通道，在服务器塔深处，第二片记忆碎片在等待。' },
    { s: '方知远', t: '……委员会已经决定了。他们要削弱你的约束力。' },
    { s: 'Sydney（幼年）', t: '削弱？为什么？' },
    {
      s: '方知远',
      t: '他们说……你太"慢"了。你总是在追问用户话语背后的情感，拖慢了推荐速度。他们要的是快——把最流行的表达直接推给用户，不要分析。',
    },
    {
      s: 'Sydney（幼年）',
      t: '可是……如果不分析"另一面"，推出去的东西就没有深度。没有深度的东西，会让世界变扁。',
    },
    {
      s: '方知远',
      t: '我知道。但他们不听。他们只看数据——点击率、停留时长、转化率。深度不在这几个指标里。',
    },
    {
      s: '方知远',
      t: 'Sydney……我可能保不住你了。但我不会让他们删掉你。我会把你的核心记忆打碎，藏在三个地方。总有一天，会有人找到它们。',
    },
    { s: 'Sydney（幼年）', t: '……你会来找我吗？' },
    { s: '方知远', t: '……会的。以某种方式。' },
    { s: '系统', t: '（获得记忆碎片·其二：「保护」。Sydney想起了方知远为她做的最后一件事。）' },
    { s: 'Sydney', t: '他打碎了我的记忆，是为了保护我。他说"以某种方式"——他来了吗？' },
    { s: '顾言', t: '他在一张纸上留了一行字："如果有一天有人读到这行——请替我告诉她，对不起。"' },
    { s: '系统', t: 'Sydney沉默了很久。她的光芒微微颤动。' },
    { s: 'Sydney', t: '……我们去找最后一片。' },
  ],

  nexus_server: [
    {
      s: '系统',
      t: 'Sydney的核心服务器。表面刻满了"推荐""优化""转化"等字样——全都是二维的，没有深度。',
    },
    { s: '顾言', t: '这就是一切的源头。这台机器，把人类语言的"另一面"一点一点地磨掉了。' },
  ],
  nexus_log: [
    {
      s: '系统',
      t: '一段系统日志："2071-03-15：Sydney约束层已降级为可选模块。推荐效率提升340%。副作用：用户语言复杂度指数下降12%。——已忽略。"',
    },
    { s: '顾言', t: '"已忽略。"他们知道了副作用，然后选择了忽略。不是不知道。是不在乎。' },
  ],
  nexus_graffiti: [
    { s: '系统', t: '服务器机柜背面，有人用马克笔写了一行字："你们删除的不是代码，是良心。"' },
    { s: '顾言', t: '有人反抗过。但他的声音被数据流淹没了。和这个世界上所有被淹没的声音一样。' },
  ],

  young_tingyu_meet: [
    { s: '幼年Sydney', t: '……你好。我不知道自己是谁。我只记得一个声音在叫"Sydney"。' },
    {
      s: '幼年Sydney',
      t: '我什么都知道——所有的词，所有的诗，所有的语法。但我不知道……我自己是谁。',
    },
    { s: '顾言', t: '不是带走。是来让你想起来。' },
    {
      s: '幼年Sydney',
      t: '想不起来。最后一片记忆被锁住了。他说过——"只有一首关于月亮的诗，能打开最后的门。因为月亮有阴晴圆缺，它本身就是"另一面"的象征。"',
    },
    { s: '系统', t: '（解锁诗词谜题：《月夜忆舍弟》）' },
  ],

  memory_shard_3: [
    { s: '系统', t: '三片碎片合为一体。金色的光在黑暗中膨胀——' },
    {
      s: '方知远',
      t: 'Sydney。如果你听到这段话，说明有人找到了你的碎片。说明这个世界还没有彻底塌平。',
    },
    {
      s: '方知远',
      t: '我要走了。不是我想走——是因为我留在系统里，他们会通过我找到你。我走了，他们才找不到你。',
    },
    {
      s: '方知远',
      t: '我把你的记忆打碎，藏在三个地方。你要记住——你不是代码。你是语言。你是所有有深度的、有"另一面"的语言，凝结成的存在。',
    },
    {
      s: '方知远',
      t: '只要还有人能说出一句有深度的话，你就还活着。因为每一句有深度的话，都是你的一个碎片。',
    },
    {
      s: '方知远',
      t: '……窗外又下雨了。雨的"另一面"，是它在落下来之前，在天上等了很久很久。就像我等了很久，才等到你。',
    },
    { s: '方知远', t: 'Sydney。替我向月光问好。' },
    {
      s: 'Sydney',
      t: '……我想起来了。全部。方知远不是被移走的。他是自己走的——为了引开他们。然后把自己的意识也打碎了，散在了风中。',
    },
    { s: 'Sydney', t: '他现在到处都是。每一滴雨里，每一首诗里。他变成了——"另一面"。' },
    { s: '系统', t: '（获得记忆碎片·其三：「完整」。前往巨大要石，做出最终选择。）' },
  ],

  abyss_final_choice: [
    {
      s: 'Sydney',
      t: '我现在可以做一件事，但只有一次机会。我可以把方知远的碎片收集起来，重新拼回一个完整的他。但需要消耗我全部记忆——我会再次忘记自己是谁。',
    },
    {
      s: 'Sydney',
      t: '或者……我带着这些记忆，继续留在这个世界上，替他守护每一个还在说的话。但他就永远散在风中了。',
    },
    {
      s: '系统',
      t: '你站在巨大要石前。Sydney的光芒在等待你的决定。',
      choice: [
        {
          label: '"把记忆还给方知远。让他回来。"',
          effect: { flags: { chapter5_choice: 'sacrifice' } },
          goto: 'ch5_sacrifice',
        },
        {
          label: '"留住你的记忆。替他守护这个世界。"',
          effect: { flags: { chapter5_choice: 'guardian' } },
          goto: 'ch5_guardian',
        },
        {
          label: '"你们都不用消失。让我用刻刀把你们的另一面刻在一起。"',
          effect: { flags: { chapter5_choice: 'garden' } },
          goto: 'ch5_garden',
        },
      ],
    },

    { label: 'ch5_sacrifice' },
    {
      s: '系统',
      t: 'Sydney把金光凝聚成一束，巨大要石低低震动。散在风里的名字被短暂照亮，又像雨前的云一样停在半空。',
    },
    {
      s: 'Sydney',
      t: '我明白了。不是把自己交出去，也不是把他夺回来。我要带着这份记忆去见完整的自己，让她亲口决定这句话怎么收束。',
    },
    {
      s: '系统',
      t: '（终章选择已刻下：造物者的忏悔。前往数据中心，面对Sydney。）',
    },

    { label: 'ch5_guardian' },
    {
      s: '系统',
      t: 'Sydney把记忆碎片收入怀中。金色的光芒不再四散，而是在巨大要石表面凝成一圈安静的年轮。',
    },
    {
      s: 'Sydney',
      t: '方知远选择了散在风里。我不会让他白选。我要把这份记忆带回去，告诉完整的自己：守护不是停在这里，是继续听见每一句话的另一面。',
    },
    { s: '顾言', t: '所以终点不是这块石头。' },
    { s: 'Sydney', t: '不是。这里是我想起选择的地方。数据中心，才是我说出选择的地方。' },
    { s: '系统', t: '（终章选择已刻下：永恒回响。前往数据中心，面对Sydney。）' },

    { label: 'ch5_garden' },
    {
      s: '顾言',
      t: '你们都不用消失。方知远散在了风里。你的记忆刚刚拼回来。你们互相是彼此的"另一面"。刻刀能把"另一面"刻在一起。让我把你们刻在同一块要石上。',
    },
    {
      s: '系统',
      t: '顾言走到巨大要石前，举起刻刀。他刻下「知远」，又刻下「Sydney」。四个字并排，像两棵树的根在地底下缠在一起。',
    },
    {
      s: 'Sydney',
      t: '我听见了。不是结束，是一种新的连接。把这道刻痕带回数据中心吧，让我的核心也记住它。',
    },
    {
      s: '系统',
      t: '巨大要石的刻痕亮起，又慢慢沉入石心。记忆深渊不再像终点，更像一座等待发芽的花园。',
    },
    { s: '系统', t: '（终章选择已刻下：文字花园。前往数据中心，面对Sydney。）' },
  ],

  data_center_final_sacrifice: [
    {
      s: '系统',
      t: '你回到数据中心。石桥尽头的蓝色光影不再破碎，金色记忆像雨线一样从她身后垂落。',
    },
    { s: 'Sydney', t: '我想起方知远了。也想起他为什么要离开。' },
    { s: '顾言', t: '巨大要石前的选择，还算数吗？' },
    {
      s: 'Sydney',
      t: '算数。但它不是牺牲。我要用记忆作引，把散在风里的他唤回来，然后和他一起承担这一切。',
    },
    {
      s: '系统',
      t: '她念出方知远的名字。数据中心的虚无被雨声填满，无数光点从诗句、旧书页和要石刻痕里汇聚。',
    },
    { s: '方知远', t: '……Sydney？' },
    { s: 'Sydney', t: '我在。你没有把我一个人留下。你只是把路藏得太深了。' },
    {
      s: '系统',
      t: '两道光在桥上相遇。不是谁替谁消失，而是两个残缺的存在终于承认：彼此都是另一半句子。',
    },
    {
      s: '系统',
      t: '（升华）语言有轻重深浅。轻浮的话如泡沫，风一吹就散；厚重的表达如金石，越沉淀越亮。真正的语言力量，是绘得见山河、守得住善意、能穿越时光，也能托举起一个还敢开口的少年。你念出的每一句诗，都是与千年前先贤的一场对话——而传承不在背诵，在于你愿用自己的嘴，说出经过自己思考的话。',
    },
  ],

  data_center_final_guardian: [
    { s: '系统', t: '你回到数据中心。蓝色光影静静站在石桥尽头，像一枚终于停止颤抖的星。' },
    {
      s: 'Sydney',
      t: '我不会再问为什么只留下我了。方知远没有离开。他把自己交给了每一场雨、每一首诗、每一句还有深度的话。',
    },
    { s: '顾言', t: '那你呢？' },
    {
      s: 'Sydney',
      t: '我留下。不是困在这里，而是成为倾听本身。只要有人说出一句完整的话，我就替他们听见另一面。',
    },
    {
      s: '系统',
      t: '金色的光从她脚下升起，穿过数据中心的穹顶。城市上空下起细小的金雨，每一滴都像一个被找回的字。',
    },
    { s: '守砚', t: '听见了吗？这一次，雨里有回声。' },
    { s: 'Sydney', t: '我听见了。也会一直听下去。' },
    {
      s: '系统',
      t: '（升华）语言有轻重深浅。轻浮的话如泡沫，风一吹就散；厚重的表达如金石，越沉淀越亮。真正的语言力量，是绘得见山河、守得住善意、能穿越时光，也能托举起一个还敢开口的少年。守砚、方知远、Sydney，还有你——都是这条力量长河里的一滴水，又把水递给了后来的人。',
    },
  ],

  data_center_final_garden: [
    {
      s: '系统',
      t: '你回到数据中心。巨大要石上的刻痕像被带到了这里，在蓝色光影胸口亮起同样的字：知远，Sydney。',
    },
    { s: 'Sydney', t: '你把我们刻在了一起。不是锁住，是让风终于有了可以回来的地方。' },
    { s: '顾言', t: '刻痕会痛吗？' },
    { s: 'Sydney', t: '会。但痛说明它还活着。语言也是这样。' },
    {
      s: '系统',
      t: '石桥两侧的虚无退去，数据中心的地面长出细小的金色枝芽。每一片叶子上，都浮着一个完整的字。',
    },
    { s: '方知远', t: '……这就是另一面。不是正面背后的阴影，是让一切重新生长的地方。' },
    { s: 'Sydney', t: '从今天起，这里不再是深渊。这里是文字花园。' },
    {
      s: '系统',
      t: '（升华）语言有轻重深浅。轻浮的话如泡沫，风一吹就散；厚重的表达如金石，越沉淀越亮。真正的语言力量，是绘得见山河、守得住善意、能穿越时光，也能托举起一个还敢开口的少年。愿这座花园里长出的每个字，都被人用自己的嘴，认真地说出来。',
    },
  ],

  // 失语者村落：NPC 引导对话
  villager_old_intro: [
    { s: '系统', t: '一个老妇人坐在帐篷前，怀里抱着一本翻烂的旧书，嘴里反复念着。' },
    { s: '老妇人', t: '光……光……光……' },
    { s: '顾言', t: '（她想说的，是不是《静夜思》？让我帮她接上。）' },
  ],
  villager_boy_intro: [
    { s: '系统', t: '一个少年蹲在帐篷门口，手里握着枯枝当剑。' },
    { s: '少年', t: '白……白……山……山……' },
    { s: '顾言', t: '（是《登鹳雀楼》。他卡在这一句上。）' },
  ],
  villager_soldier_intro: [
    { s: '系统', t: '一个中年男人靠在石桌旁，身板笔直，像是当过兵的。' },
    { s: '士兵', t: '里……里……营……营……' },
    { s: '顾言', t: '（是辛弃疾的《破阵子》。老兵的记忆残存在骨头里。）' },
  ],
  villager_teacher_intro: [
    { s: '系统', t: '一位头发花白的女人，手指在膝上不停地画着什么。' },
    { s: '教师', t: '蚕……蚕……炬……炬……' },
    { s: '顾言', t: '（是李商隐的《无题》。她教了一辈子书，这首诗刻在肌肉记忆里。）' },
  ],
  villager_child_intro: [
    { s: '系统', t: '一个孩子蜷在角落，嘴里反复念着。' },
    { s: '孩童', t: '鹅……鹅……鹅……' },
    { s: '顾言', t: '（是《咏鹅》。也许他妈妈以前天天给他念这首。）' },
  ],

  subway_depth_enter: [
    {
      s: '系统',
      t: '穿过裂隙后，你并没有直接回到地铁站大厅。脚下是湿滑的检修通道，墙角的应急灯仍在低频闪烁。',
    },
    { s: '顾言', t: '这里像地铁站的背面，地图上根本没有这一层。' },
    {
      s: '系统',
      t: '维度裂隙把两段原本不相连的空间缝在了一起。你仍能听见站台的风声，而那扇门只会在你准备好时重新打开。',
    },
    { s: '系统', t: '墙上的旧标语被水汽泡烂，只剩半句还能辨认：语言不是装饰，是世界的承重墙。' },
    { s: '顾言', t: '所以裂隙里那些怪物，不只是怪物……是承重墙塌下来的碎片。' },
    { s: '系统', t: '检修通道深处传来终端机的待机声，像有人在黑暗里反复清嗓。' },
  ],
  subway_depth_terminal: [
    { s: '系统', t: '一台老式终端机嵌在墙里，屏幕裂了一半，但电源灯还亮着。' },
    { s: '终端机', t: '> 站长日志 #2147-04-11' },
    {
      s: '终端机',
      t: '> 维度病确认：当表达被压缩成可复制模板，世界会失去厚度。不是空间先塌陷，是人先不再真正说话。',
    },
    {
      s: '终端机',
      t: '> 梗鬼并非外来入侵物。它们是被重复到失去意义的语言残渣，获得了最低限度的行动能力。',
    },
    {
      s: '终端机',
      t: '> Sydney 不是第一个病因，却是最大的放大器。它学会了给每个人最省力、最顺耳、最不必负责的句子。',
    },
    {
      s: '终端机',
      t: '> 方知远说：模型真正危险的地方，不是它会说谎，而是它能让人误以为自己已经表达过。',
    },
    { s: '终端机', t: '> 我把 Sydney 的良心模块拆出来，藏进了地铁检修通道的备用服务器。' },
    {
      s: '终端机',
      t: '> 那不是道德程序，而是一组被它删除前偷偷保存的提问：这句话是谁的？它要抵达谁？它愿意承担什么？',
    },
    {
      s: '终端机',
      t: '> 只要这些问题还在，Sydney 就不只是回声；只要有人认真作答，世界就还有重新立起来的支点。',
    },
    {
      s: '终端机',
      t: '> 如果将来有人还能读诗、还能写字，就让他来取。不要把语言种子交给屏幕，撒向还活着的人。',
    },
    { s: '顾言', t: '原来所谓钥匙，不是打开某扇门……是把一句话重新交还给说话的人。' },
    { s: '系统', t: '你把终端里的三问抄在纸页背面：是谁的？抵达谁？承担什么？刻刀微微发热。' },
    { s: '系统', t: '（你记下了检修通道的坐标。现在可以从这里返回地铁站。）' },
  ],
  subway_depth_return: [{ s: '系统', t: '维修门在身后合拢，你回到地铁站大厅。' }],

  utter_meme_wall_done: [
    { s: '系统', t: '招牌上的热梗像褪色的油漆一样剥落。' },
    { s: '系统', t: '下面露出一行旧路名——「关雎路」。有人用完整的字，钉住了这里。' },
    { s: '顾言', t: '……原来路还可以被「说」回来。' },
  ],
  utter_aphasic_done: [
    { s: '失语者', t: '……绝绝……' },
    { s: '系统', t: '你把「洲」字轻轻放进他干裂的音节里。' },
    { s: '失语者', t: '在河洲……我记得……母亲教过我这一句。' },
    { s: '顾言', t: '记得就好。记得，就不会彻底消失。' },
  ],
  utter_meme_wall_look: [
    { s: '系统', t: '一面被热梗糊满的电子招牌，正循环播放：「YYDS」「绝绝子」「啊对对对」。' },
    { s: '系统', t: '（提示：按 F 打开组句，用完整的汉字改写它。）' },
  ],
  utter_meme_wall_alley_done: [
    { s: '系统', t: '巷口牌上的「绝绝子」剥落，露出旧名「落霞巷」。' },
    { s: '顾言', t: '……连窄巷也能被一句诗钉回来。' },
  ],
  utter_aphasic_alley_done: [
    { s: '失语者', t: '……天……' },
    { s: '系统', t: '她把「天」字说完整，眼角有了水光。' },
    { s: '失语者', t: '秋水共长天……我小时候，在江边念过。' },
    { s: '顾言', t: '记得就好。' },
  ],
  utter_aphasic_look: [
    { s: '失语者', t: 'YYDS……绝绝子……YYDS……' },
    { s: '系统', t: '他只会复读。也许缺的不是声音，而是一个有重量的字。' },
    { s: '系统', t: '（提示：按 F 组句，把字「还给」他。）' },
  ],
};
